import React from 'react';

// Catches render-time exceptions so a single component error shows a friendly
// recovery screen instead of white-screening the whole app.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
          <div className="bg-card border border-border/70 rounded-2xl shadow-soft p-8 max-w-md text-center">
            <div className="w-14 h-14 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl">😅</div>
            <h1 className="text-xl font-display font-semibold text-foreground mb-2">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-6">This page hit an unexpected error. Reloading usually fixes it — your data is safe.</p>
            <div className="flex gap-2 justify-center">
              <button onClick={() => window.location.reload()} className="bg-primary text-primary-foreground rounded-xl px-5 h-11 text-sm font-semibold btn-anim shadow-soft hover:bg-primary/90 cursor-pointer">Reload page</button>
              <a href="/" className="inline-flex items-center border border-border bg-card text-foreground rounded-xl px-5 h-11 text-sm font-medium btn-anim hover:bg-secondary/60 no-underline">Go home</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
